'use client';

import { useRouter } from 'next/navigation';
import { useSelector } from 'react-redux';

import Conditional from '@next-app/components/Conditional';
import Link from '@next-app/components/elements/Link/Link';
import { selectEmailInfo } from '@next-app/lib/features/checkout/CheckoutSelector';
import {
  selectDynSess,
  selectIsFurniture,
  selectIsLoggedIn,
  selectUserProfileId,
} from '@next-app/lib/features/InitSelectors';
import { logoutUser } from '@next-app/utils/authenticationUser';
import LLHeading from '@next-app/components/elements/LLHeading/LLHeading';

/**
 * RenderShipUserContactSection
 * render ship type expended form
 */
const LoggedInContactSection = (): React.JSX.Element => {
  const router = useRouter();

  // selectors
  const dynSessConfNumber = useSelector(selectDynSess) || '';
  const emailInfo = useSelector(selectEmailInfo) || {};
  const userProfileId = useSelector(selectUserProfileId);
  const isLoginUser = useSelector(selectIsLoggedIn);
  const isFurniture = useSelector(selectIsFurniture);

  const { email = '' } = emailInfo;

  // methods
  /**
   * handleLogout
   */
  const handleLogout = async () => {
    await logoutUser(userProfileId, dynSessConfNumber, isFurniture);
  };

  return (
    <div className="mb-3 mt-3">
      <Conditional if={isLoginUser}>
        <>
          <LLHeading tagName="2" className="7">
            Email Address
          </LLHeading>
          <div className="mt-3">
            <strong className="d-block">{email}</strong>
            <Link className="btn btn-link" href="/" onClick={handleLogout}>
              {'Log out'}
            </Link>
          </div>
        </>
      </Conditional>
    </div>
  );
};
export default LoggedInContactSection;
